import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  HostBinding,
  OnDestroy
} from '@angular/core';
import { MediaService } from '../media.service';
import { AutoUnsubscribe } from '../../../utils/misc/auto-unsubscribe';
import { OnDestroyComponent } from '../../../shared/components/on-destroy/on-destroy.component';
import { MISC_CONST } from '../../../utils/const/misc';
import { ToastrService } from '../../../shared/services/utilities/toastr.service';
import { UploaderOptions, UploadFile, UploadInput, UploadOutput } from "../../../utils/kz-uploader";

@Component({
    selector: 'app-media-upload',
    templateUrl: './media-upload.component.html',
    styleUrls: ['./media-upload.component.scss']
})
@AutoUnsubscribe([
  'uploadInput'
])
export class MediaUploadComponent extends OnDestroyComponent implements OnDestroy, OnInit {
  @Input() imageOfKaza = true;
  @Input() video = false;
  @Input() kaza: any;
  @Input() type: string;
  @Input() medias?: any;
  @Input() menuOfKaza = true;
  @Input() imageOfKazaEnabled = false;
  @Input() showProgress = false;
  @Input() showMaxLimit = true;
  @Input() minHeight: number;
  @Input() minWidth: number;
  @Input() maxMedia = 1;
  @Input() modeLite = false;
  @Input() showUploadVideo = false;
  @Input() showUploadMedia = true;

  @Output() fileUploaded: EventEmitter<any> = new EventEmitter();
  @Output() fileAdded: EventEmitter<UploadFile> = new EventEmitter();
  @Output() fileError?: EventEmitter<any> = new EventEmitter();
  @Output() videoUploaded?: EventEmitter<any> = new EventEmitter();
  @Output() videoAdded?: EventEmitter<UploadFile> = new EventEmitter();
  @Output() videoError?: EventEmitter<any> = new EventEmitter();
  @Output() imageOfKazaDisplayed: EventEmitter<boolean> = new EventEmitter();
  @Output() fileSelectedInKaza: EventEmitter<any> = new EventEmitter();

  @ViewChild('inputFile', {static: false}) inputFile: ElementRef;
  @ViewChild('inputVideo', {static: false}) inputVideo: ElementRef;
  @HostBinding('class.show-kaza-answer') public get isActive(): boolean {
    return this.imageOfKazaEnabled;
  }
  @HostBinding('class.full-width') public get fullWidth(): boolean {
    return !this.imageOfKaza;
  }
  @HostBinding('class.design--pro') public get isPro(): boolean {
    return this.type === 'proService';
  }

  public uploadInput: EventEmitter<UploadInput>;
  public files: UploadFile[];
  public options: UploaderOptions;
  public optionsVideo: UploaderOptions;
  public showErrorUpload = false;
  public showErrorSize = false;
  public errors: any;
  public requestParameters: any;
  public allowedContentTypes: string[] = ['image/jpeg', 'image/png', 'image/heic', 'image/heif', 'image/hevc'];
  public allowedContentTypesVideo: string[] = ['video/mp4', 'video/ogg', 'video/webm', 'video/x-msvideo', 'video/mpeg', 'video/quicktime'];
  public id: string;
  public idVideo: string;
  public dragOver: boolean;
  public maxFileSize: number;

  constructor(
      public mediaService: MediaService,
      protected readonly toastrService: ToastrService,
  ) {
    super();
    this.id = this.generateId();
    this.idVideo = this.generateId();
    this.maxFileSize = MISC_CONST.POST_MAX_FILE_SIZE;
    this.uploadInput = this.mediaService.uploadInput;
  }

  ngOnInit(): void {
    this.requestParameters = {
      type: this.type
    };
    this.options = { concurrency: 3, maxUploads: this.maxMedia, allowedContentTypes: this.allowedContentTypes };
    this.optionsVideo = { concurrency: 1, maxUploads: 1, allowedContentTypes: this.allowedContentTypesVideo, maxFileSize: (MISC_CONST.POST_MAX_FILE_SIZE * 2)};
  }

  onUploadOutput(output: UploadOutput, autoStart = true, isVideo= false): void {
    if (output.type === 'allAddedToQueue') {
      if (autoStart) {
        this.mediaService.save(this.requestParameters);
      }
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
      if (this.inputFile) {
        this.inputFile.nativeElement.value = null;
      }
      if (this.inputVideo) {
        this.inputVideo.nativeElement.value = null;
      }

      this.showErrorSize = false;
      this.showErrorUpload = false;
      this.errors = null;

      if (isVideo) {
        this.videoAdded.emit(output.file);
      } else {
        this.fileAdded.emit(output.file);
      }

      this.mediaService.onUploadOutput(output);
    } else if (output.type === 'removed') {
      this.mediaService.onUploadOutput(output);
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      if (output.file.size > MISC_CONST.POST_MAX_FILE_SIZE) {
        this.showErrorSize = true;
      }
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      this.mediaService.onUploadOutput(output);
    } else if (output.type === 'done' && typeof output.file !== 'undefined') {

      if (output.file.responseStatus === 200 || output.file.responseStatus === 201) {
        if (isVideo) {
          this.videoUploaded.emit(output.file.response);
        } else {
          this.fileUploaded.emit(output.file.response);
        }
      } else if (output.file.responseStatus === 413) {
        this.showErrorSize = true;

        this.handleErrorUpload(output);

      } else {
        this.errors = output.file.response;
        if (!this.errors) {
          this.showErrorUpload = true;
        }
        this.handleErrorUpload(output);
      }
    } else if (output.type === 'dragOver') { // drag over event
      this.dragOver = true;
    } else if (output.type === 'dragOut') { // drag out event
      this.dragOver = false;
    } else if (output.type === 'drop') { // on drop event
      this.dragOver = false;
    }
  }

  handleErrorUpload(output: any): void {
    this.toastrService.error($localize`:@@toast.error_with_description:An error has occurred \: ${output.file.name}:description:`);
    this.uploadInput.emit({ type: 'remove', id: output.file.id });
    if (this.inputFile) {
      this.inputFile.nativeElement.value = null;
    }
    if (this.inputVideo) {
      this.inputVideo.nativeElement.value = null;
    }
    if (this.fileError) {
      this.fileError.emit(output.file.response);
    }
  }


  showImageOfKaza() {
    this.showErrorUpload = false;
    this.showErrorSize = false;
    this.errors = null;
    this.imageOfKazaEnabled = true;
    this.imageOfKazaDisplayed.emit(true);
  }

  mediasChange(media): void {
    this.fileSelectedInKaza.emit(media);
  }

  generateId(): string {
    return Math.random().toString(36).substring(7);
  }

  ngOnDestroy() {
    this.mediaService.removeAllMedia();
    super.ngOnDestroy();
  }
}
